/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Plans_BusinessInputs */

const es_admin_company_overview_plans_business = /** @type {(inputs: Admin_Company_Overview_Plans_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

const en_admin_company_overview_plans_business = /** @type {(inputs: Admin_Company_Overview_Plans_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

/**
* | output |
* | --- |
* | "Business" |
*
* @param {Admin_Company_Overview_Plans_BusinessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_plans_business = /** @type {((inputs?: Admin_Company_Overview_Plans_BusinessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Plans_BusinessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_plans_business(inputs)
	return en_admin_company_overview_plans_business(inputs)
});
export { admin_company_overview_plans_business as "admin.company_overview.plans.business" }